import { useLocation } from 'react-router-dom';
import { useSeo } from '../../hooks/useSeo';
import { buildDocsJsonLd, getDocsPageMeta } from './seo';

/**
 * Centralized SEO + JSON-LD for every docs route. Mounted once in
 * `DocsLayout`'s `<Shell>` so individual guide/concept/API pages don't each
 * need their own `useSeo` call — this reads the current route and looks up
 * its metadata from `seo.ts`, which is itself derived from the same data
 * (`GUIDES`, `ENTITIES`) those pages already render from.
 *
 * Falls back to the generic docs description for any route not in the
 * lookup (e.g. a typo'd path that resolves to the catch-all `Concept` route)
 * rather than rendering no meta tags at all.
 */
export function DocsSeo() {
  const { pathname } = useLocation();
  const meta = getDocsPageMeta(pathname) ?? getDocsPageMeta('/docs');

  useSeo({
    title: meta!.title,
    description: meta!.description,
    path: pathname,
    type: 'website',
    jsonLd: buildDocsJsonLd(meta!, pathname),
  });

  return null;
}
